import { pageLoadDataParams } from './constants';
import { PesAnalyticsType } from './types/analytics';

declare global {
  interface Window {
    pesAnalytics: PesAnalyticsType;
  }
}

const defaultPageLoadDataParams = [
  pageLoadDataParams.DIGITAL_PLATFORM,
  pageLoadDataParams.DIGITAL_PLATFORM_COUNTRY,
  pageLoadDataParams.ENVIRONMENT,
];

// eslint-disable-next-line @typescript-eslint/naming-convention
enum pageLoadDataToAnalytics {
  digitalPlatform = 'digital_platform',
  digitalPlatformCountry = 'digital_platform_country',
  environment = 'environment',
}

export const addPageLoadDataInfoToAnalyticsEvent = (
  params = defaultPageLoadDataParams,
): Record<string, unknown> => {
  const pageLoadData = window?.pesAnalytics?.pageLoadData;

  return pageLoadData
    ? params.reduce((acc, curr) => {
      if (Object.getOwnPropertyDescriptor(pageLoadData, curr)) {
        acc[pageLoadDataToAnalytics[curr]] = pageLoadData[curr];
      }

      return acc;
    }, {})
    : {};
};
